import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import api from '../../API/api';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function CustomizedMenus(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openModal, setOpenModal] = React.useState(false);

  const handleClickOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [modalData, setModalData] = React.useState({
    title: '',
    label: '',
    text: '',

  })

  const handleInput = (e) => {
    setModalData({
      ...modalData, 'text': e.target.value
    })
  }

  const handleAction = (type) => {

    switch (type) {
      case 'remarks':
        setModalData({
          title: 'Enter Remarks',
          label: 'Remark'
        });

        break;

      case 'mail':
        setModalData({
          title: 'Enter Message To Send',
          label: 'Email'
        })
        break;

    }

    handleClickOpenModal();
  }

  const sendMailToStudent = () => {
    // console.log(modalData.text, props.id);
    api.sendMailToStudent(modalData.text, props.id).then((res) => {
      // console.log(res);
      handleCloseModal();
      handleClose();

      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    })
      .catch((err) => {
        // console.log(err.response);
      })

  }


  const saveRemark = () => {
    api.saveRemark(props.id.id, modalData.text).then((res) => {
      // console.log(res);
      props.getAdmissionData();
      handleCloseModal();
      handleClose();

    })
      .catch((err) => {
        // console.log(err.response);
      })
  }

  const handleDetails =(data)=> {
    // navigate('/admin/AdmissionDetails', { state: { data:data } })
    try {
      // Ensure data is serializable
      const serializableData = JSON.parse(JSON.stringify(data));
      
      // Navigate with valid state
      navigate('/admin/AdmissionDetails', { 
        state: { 
          data: serializableData.id 
        } 
      });
    } catch (error) {
      console.error('Navigation error:', error);
      // Fallback navigation without state
      navigate('/admin/AdmissionDetails');
    }
  }


  const modal = () => {
    return (
      <>
      <ToastContainer />
        <div>
          {/* <Button variant="outlined" onClick={handleClickOpenModal}>
            Open form dialog
          </Button> */}
          <Dialog fullWidth={true} maxWidth='md' open={openModal} onClose={handleClose}>
            <DialogTitle>{modalData.title}</DialogTitle>
            <DialogContent>
            
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label={modalData.label}
                type="text"
                fullWidth
                variant="standard"
                value={modalData.text}
                onChange={handleInput}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseModal}>Cancel</Button>
              {modalData.label === 'Remark' &&
                <Button onClick={saveRemark}>Save</Button>
              }
              {modalData.label === 'Email' &&
                <Button onClick={sendMailToStudent}>Send</Button>
              }

              {/* <Button onClick={handleCloseModal}>Send</Button> */}
            </DialogActions>
          </Dialog>
        </div>
      </>
    )
  }



  return (
    <div>
      
      {modal()}
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        // variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<EditIcon />}
      >
        {/* Options */}
      </Button>



      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleAction('remarks')} disableRipple>
          <EditIcon />
          Create Remaks
        </MenuItem>

        {/* <MenuItem onClick={() => handleDelete(props.id)} disableRipple>
          <DeleteIcon />
          Delete
        </MenuItem> */}

        <MenuItem onClick={() => handleAction('mail')} disableRipple>
          <FileCopyIcon />
          Send Mail
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={()=> handleDetails(props)} disableRipple>
          <ArchiveIcon />
          Check Details
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          <MoreHorizIcon />
          More
        </MenuItem>
      </StyledMenu>
    </div>
  );
}